import o, { css } from 'styled-components';
import { jsx } from 'react/jsx-runtime';

var g=css`
  font-size: var(--font-size-small);
  line-height: var(--line-height-large);
`,i=css`
  font-size: var(--font-size-regular);
  line-height: var(--line-height-regular);
  letter-spacing: var(--letter-spacing-regular);
`,p=css`
  font-size: var(--font-size-medium);
  line-height: var(--line-height-small);
`,c=css`
  font-size: var(--font-size-x-x-large);
  line-height: var(--line-height-x-small);
`,h=css`
  font-weight: var(--font-weight-bold);
`,m=css`
  font-weight: var(--font-weight-semibold);
`,d=css`
  font-weight: var(--font-weight-regular);
`,f=css`
  letter-spacing: var(--letter-spacing-dense);
`,v=css`
  letter-spacing: var(--letter-spacing-spacious);
`,P=i,$="foreground-secondary",u=o.p`
  margin: 0;
  ${i}
  ${d}
  ${({$size:e})=>e==="small"&&g}
  ${({$size:e})=>e==="medium"&&p}
  ${({$size:e})=>e==="large"&&c}
  ${({$weight:e})=>e==="bold"&&h}
  ${({$weight:e})=>e==="semibold"&&m}
  ${({$colorToken:e})=>e&&`color: var(--${e});`}
  ${({$letterSpacing:e})=>e==="dense"&&f}
  ${({$letterSpacing:e})=>e==="spacious"&&v}
`,x=({size:e,weight:r,colorToken:s=$,letterSpacing:n,children:l,...a})=>jsx(u,{$size:e,$weight:r,$colorToken:s,$letterSpacing:n,...a,children:l}),w=o(x)``;

export { P as a, $ as b, u as c, w as d };
